"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FAQStructuredData = void 0;
var StructuredData_1 = require("./StructuredData");
var FAQStructuredData = /** @class */ (function () {
    function FAQStructuredData(elements) {
        this.elements = elements;
    }
    FAQStructuredData.prototype.generate = function () {
        var _this = this;
        var faqData = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            'mainEntity': [],
        };
        this.elements.forEach(function (list) {
            var items = list.querySelectorAll('.expandable');
            items.forEach(function (item) {
                var _a, _b, _c, _d, _e, _f, _g;
                var question = (_e = (_b = (_a = item.querySelector('.expandable__header')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-title')) !== null && _b !== void 0 ? _b : (_d = (_c = item.querySelector('.expandable__title')) === null || _c === void 0 ? void 0 : _c.textContent) === null || _d === void 0 ? void 0 : _d.trim()) !== null && _e !== void 0 ? _e : '';
                var rawAnswer = (_g = (_f = item.querySelector('.expandable__body')) === null || _f === void 0 ? void 0 : _f.innerHTML) !== null && _g !== void 0 ? _g : '';
                var answer = _this.sanitizeHtml(rawAnswer);
                if (question && answer) {
                    faqData.mainEntity.push({
                        '@type': 'Question',
                        'name': question,
                        'acceptedAnswer': {
                            '@type': 'Answer',
                            'text': answer,
                        },
                    });
                }
            });
        });
        if (faqData.mainEntity.length > 0) {
            StructuredData_1.StructuredDataUtils.insertToDOM(faqData);
        }
    };
    FAQStructuredData.prototype.sanitizeHtml = function (html) {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        var allowedTags = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'BR', 'OL', 'UL', 'LI', 'A', 'P', 'DIV', 'B', 'STRONG', 'I', 'EM'];
        var allElements = tempDiv.querySelectorAll('*');
        allElements.forEach(function (el) {
            if (!allowedTags.includes(el.tagName)) {
                var parent_1 = el.parentNode;
                while (el.firstChild) {
                    parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.insertBefore(el.firstChild, el);
                }
                parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.removeChild(el);
            }
        });
        return tempDiv.innerHTML.replace(/\s+/g, ' ').trim();
    };
    return FAQStructuredData;
}());
exports.FAQStructuredData = FAQStructuredData;
